import * as Immutable from "immutable";
import { useQuery } from "@tanstack/react-query";
import TeamsDomain from "../domainActions/TeamsDomain";
const DEFAULT_PAGINATION = { page: 1, perPage: 0, query: "" };
const getTeamUsersPerRole = (teams) => {
  let teamUsersPerRole = Immutable.Map();
  teams.list.forEach((team) => {
    if (team.users.size === 0 || team.roles.size === 0) {
      return;
    }
    const teamUsers = Immutable.Set(
      team.users.map((userId) => ({ id: userId, username: `${teams.context.users.get(userId).title} (${team.name})` }))
    );
    team.roles.forEach((roleId) => {
      var _a;
      teamUsersPerRole = teamUsersPerRole.set(
        roleId,
        ((_a = teamUsersPerRole.get(roleId)) != null ? _a : Immutable.Set()).union(teamUsers)
      );
    });
  });
  return teamUsersPerRole.toJS();
};
const _loadTeamsAndGetUsers = () => TeamsDomain.loadTeamsPaginated(DEFAULT_PAGINATION).then((paginatedTeams) => getTeamUsersPerRole(paginatedTeams));
const useTeamMembersByRole = () => {
  const { data: users, isInitialLoading: loading } = useQuery({
    queryKey: ["teamMembersByRole"],
    queryFn: _loadTeamsAndGetUsers
  });
  return loading || !users ? {
    isLoading: loading,
    users: {}
  } : {
    isLoading: loading,
    users
  };
};
export default useTeamMembersByRole;
